const UserGetter = {
    user: (state) => state.user,
    users: (state) => state.users,
    auth: (state) => state.auth,
    userProfile: (state) => state.userProfile,
    cluster: (state) => state.cluster
};

export default UserGetter;